export default __webpack_public_path__ + "static/media/InsideBrain_03.c808313e.png";